import { useState, useEffect } from 'react';
import './Footer.css';
import Translator from '../../translates/Translator';
import {
    Row,
    Col
} from 'react-bootstrap';

const Footer = () => {
    const t = Translator();
    const date = new Date().getFullYear();
    const linkedinURL = 'https://www.linkedin.com/company/ika-data-spol-s-r-o-/';

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const resize = () => { (window.innerWidth < 992) ? setIsMobile(true) : setIsMobile(false); }
    useEffect(() => { window.addEventListener("resize", resize); }, [])

    const linkedInink = () => {
        return isMobile ? (
            <Row className='text-start align-items-center mb-3'>
                <h2 className='mb-5'>IKA DATA</h2>
                <Col xs={2} md={1} lg={2}>
                    <i className="fa-brands fa-linkedin fa-2xl"></i>
                </Col>
                <Col>
                    <a href={linkedinURL} target='_blank' rel="noreferrer">
                        <span className='col text-start'>{t("linkedin-information")}</span>
                    </a>
                </Col>
            </Row>
        ) : (
            <span>
                <h2 className='mb-5 pt-4'>IKA DATA</h2>
                <a href={linkedinURL} target='_blank' rel="noreferrer">
                    <span className='mb-3 mb-xl-4'>{t("linkedin-information")}</span>
                    <i className="fa-brands fa-linkedin fa-2xl"></i>
                </a>
            </span>
        );
    }

    return (
        <footer className='footer gray-dark-bg text-lightest shadow-8-2'>
            <Row className='pt-5 m-0 w-100 justify-content-center'>
                <Col xs={12} lg={3} className='ps-4 ps-sm-5 mb-3'>
                    {linkedInink()}
                </Col>
                <Col xs={12} lg={4} className='ps-4 ps-sm-5'>
                    <Row className='text-start align-items-center mb-4'>
                        <Col xs={2} md={1} lg={2} xl={1} className='me-xl-3'>
                            <i className="fa-solid fa-pen-to-square fa-2xl"></i>
                        </Col>
                        <Col>
                            <p className='m-0'>
                                IKA DATA, spol. s r.o.
                            </p>
                            <p className='m-0'>
                                Vinohradská 1899/112, 130 00 Praha 3
                            </p>
                            <p className='m-0'>
                                IČ: 26155664
                            </p>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center mb-4'>
                        <Col xs={2} md={1} lg={2} xl={1} className='me-xl-3'>
                            <i className="fa-solid fa-mobile-screen-button fa-2xl"></i>
                        </Col>
                        <Col>
                            Tel.: <a href="tel:+420601563562" className='fs-6'>+420 601 563 562</a> <br />
                            Helpdesk: <a href="tel:+420771506197" className='fs-6'>+420 771 506 197</a>
                        </Col>
                    </Row>
                    <Row className='text-start align-items-center mb-3'>
                        <Col xs={2} md={1} lg={2} xl={1} className='me-xl-3'>
                            <i className="fa-regular fa-envelope fa-2xl"></i>
                        </Col>
                        <Col>
                            <a href="mailto:sluzby@ikadata.com" className='fs-6'>Sluzby@ikadata.com</a> <br />
                            <a href="mailto:helpdesk@ikadata.com" className='fs-6'>Helpdesk@ikadata.com</a>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} lg={5} className='mt-3 mt-lg-0 px-sm-5'>
                    <Row className='text-start align-items-center mb-4 ps-3 ps-sm-1'>
                        <Col xs={2} md={1} lg={2} xxl={1}>
                            <i className="fa-solid fa-location-dot fa-2xl"></i>
                        </Col>
                        <Col>
                            U Průhonu 773/12, 170 00 Praha 7 - Holešovice
                        </Col>
                    </Row>
                    <div className='footer-map-container'>
                        <iframe
                            title="Address Map"
                            style={{ border: "0", width: "100%", height: "100%" }}
                            loading="lazy"
                            referrerPolicy="strict-origin-when-cross-origin"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3253.4684760551596!2d14.445219756308369!3d50.10458596831685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b9362c3ef85d1%3A0x6c36658b86cec876!2sIKA%20DATA%2C%20spol.%20s.r.o.!5e0!3m2!1sen!2scz!4v1786440412223!5m2!1sen!2scz"
                            allowFullScreen={true}>
                        </iframe>
                    </div>
                </Col>
            </Row>
            <p className='text-notes ls-5 mt-5'>&copy; {date} {t("footer-copyright")}</p>
        </footer>
    );
};

export default Footer;



export const FooterCopyright = () => {
    const t = Translator();
    const date = new Date().getFullYear();

    return (
        <footer className='footer-small'>
            <p className='text-notes m-0 ls-5'>
                &copy; {date} {t("footer-copyright")}
            </p>
        </footer>
    );
};